import { render, staticRenderFns } from "./Movilidad.vue?vue&type=template&id=91774410"
import script from "./Movilidad.vue?vue&type=script&lang=js"
export * from "./Movilidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports